import React, { Component, createRef } from "react";
import FocusTrap from "focus-trap-react";

import { ModalDialog } from "./ModalDialog";

export const MODAL_WINDOW_TITLE_ID = "modal-window-title-id";

const ModalWindow = ({ dialog, header, body, footer }) =>
  dialog || (
    <ModalDialog>
      <ModalDialog.Header>{header}</ModalDialog.Header>
      <ModalDialog.Body>{body}</ModalDialog.Body>
      <ModalDialog.Footer>{footer}</ModalDialog.Footer>
    </ModalDialog>
  );

const Trap = ({ isTrapped = false, children }) => {
  if (!isTrapped) return null;

  return <FocusTrap>{children}</FocusTrap>;
};

export class Modal extends Component {
  modalDialogRef = createRef();

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  render() {
    return (
      <Trap isTrapped={this.state.isOpen}>
        <div
          ref={this.modalDialogRef}
          data-testid="modal"
          onClick={this.handleBackDropClick}
          aria-labelledby={MODAL_WINDOW_TITLE_ID}
          role="dialog"
          tabIndex="-1"
        >
          <div className="modal">
            <ModalWindow {...this.options} />
          </div>
        </div>
      </Trap>
    );
  }

  show = (options, resolve, reject) => {
    document.body.classList.add("modal-open");
    this.options = options;
    this.resolveHandler = resolve;
    this.rejectHandler = reject;
    this.setState({
      isOpen: true,
    });
  };

  resolve = (data) => {
    this.resolveHandler && this.resolveHandler(data);
    this.close();
  };

  reject = (data) => {
    this.rejectHandler && this.rejectHandler(data);
    this.close();
  };

  close = () => {
    document.body.classList.remove("modal-open");
    this.setState({
      isOpen: false,
    });
    this.resolveHandler = undefined;
    this.rejectHandler = undefined;
    this.options = undefined;
  };

  handleBackDropClick = () => {
    this.reject();
  };
}
